import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedStateService {
  private postSubmissionSubject = new BehaviorSubject<boolean>(false);

  setPostSubmission(value: boolean) {
    this.postSubmissionSubject.next(value);
  }
}
